module.exports = __webpack_public_path__ + "img/feature-3.f44d4221.svg";